import { WaitlistForm } from "@/components/WaitlistForm";

export const FinalCta = () => {
  return (
    <section id="waitlist" data-testid="final-cta-section" className="py-24 text-center">
      <div className="rl-reveal mx-auto max-w-2xl px-6">
        <h2 className="mb-4 text-3xl font-bold text-white md:text-5xl">
          Run coding agents without frying your laptop
        </h2>
        <p className="mb-8 text-[#94a3b8]">
          Join the private alpha cohort. We onboard developers in weekly batches.
        </p>
        <WaitlistForm buttonLabel="Get Invites" testidPrefix="final-waitlist" centered />
      </div>
    </section>
  );
};
